export const modifyAnswers = (dAnswers) => {
  const visibleConditions = [];
  dAnswers.forEach(item => {
    visibleConditions.push({
      id: item.questionId ?? item.productQuestionId,
      value: item.id
    })
  })

  return visibleConditions;
}